import React, { useEffect } from 'react';
import { StandupPouchModel } from './StandupPouchModel';


export const Test = () => {


    return (
        <StandupPouchModel
            id='test'
            viewWidth={300}
            viewHeight={300}
            animationSpeed={0.005}
            backgroundColor={'ffffff'}
            width={200}
            height={400}
            gusset={80}
            tearNotch={1}
            hangHole={1}
            zipper={1}
            valve={1}
            roundedCorners={1}
            sealWidth={1}
            finishType={1}
            pouchColor={'c2730a'}
        />        
    )

}

